export type SentencePart =
	| { type: 'country-name'; name: string; alpha2: string }
	| { type: 'virtual-brand-name'; id: string; name: string }
	| { type: 'virtual-package-name'; id: string; name: string }
	| {
			type: 'data-source-name';
			dataSource: string;
			shortName: string;
			country: { name: string; alpha2: string };
	  }
	| { type: 'text'; text: string; emphasis: string }
	| { type: 'tooltip'; text: string; tooltip: string }
	| { type: 'monetary-amount'; amount: string; currency: string }
	| { type: 'date'; date: Date }
	| { type: 'month'; month: string }
	| { type: 'collapsed-parts-list'; collapsedParts: SentencePart[] };

export enum SentencePartType {
	countryName = 'country-name',
	virtualBrandName = 'virtual-brand-name',
	virtualPackageName = 'virtual-package-name',
	dataSourceName = 'data-source-name',
	text = 'text',
	tooltip = 'tooltip',
	monetaryAmount = 'monetary-amount',
	date = 'date',
	month = 'month',
	collapsedPartsList = 'collapsed-parts-list',
}

export type MaybePart = {
	id?: string;
	type: SentencePartType;
	text?: string;
	name?: string;
	amount?: string;
	shortName?: string;
	alpha2?: string;
	emphasis?: string;
	currency?: string;
	tooltip?: string;
	dataSource?: string;
};

function arePartsEqual(part: MaybePart, otherPart: MaybePart): boolean {
	if (part.type !== otherPart.type) {
		return false;
	}

	switch (part.type) {
		case SentencePartType.countryName:
			return part.alpha2 === otherPart.alpha2;

		case SentencePartType.virtualBrandName:
		case SentencePartType.virtualPackageName:
			return part.id === otherPart.id;

		case SentencePartType.dataSourceName:
			return part.dataSource === otherPart.dataSource;

		case SentencePartType.text:
			return part.text === otherPart.text && part.emphasis === otherPart.emphasis;

		case SentencePartType.tooltip:
			return part.text === otherPart.text && part.tooltip === otherPart.tooltip;

		case SentencePartType.monetaryAmount:
			return part.amount === otherPart.amount && part.currency === otherPart.currency;

		default:
			return false;
	}
}

export default class Sentence {
	parts: SentencePart[];

	date: Date | null;

	constructor(parts: MaybePart[], date: Date | null) {
		// NOTE: retype and rely on API returning correct stuff
		this.parts = parts as SentencePart[];
		this.date = date;
	}

	isSimilar(otherSentence: Sentence): boolean {
		if (this.parts.length !== otherSentence.parts.length) {
			return false;
		}
		return (
			this.parts.find(
				(part, i) =>
					part.type !== SentencePartType.virtualPackageName &&
					!arePartsEqual(part as MaybePart, otherSentence.parts[i] as MaybePart)
			) === undefined
		);
	}
}
